export const CODE_VARIANTS = {
  JS: 'JS',
  TS: 'TS',
};

export const CODE_STYLING = {
  SYSTEM: 'MUI System',
  TAILWIND: 'Tailwind',
  CSS: 'CSS',
};

// Valid languages to use in production
export const LANGUAGES_LABEL = [
  {
    code: 'en',
    text: 'English',
  },
];
